import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { deleteAlertusToken, selector as deleteTokenApi } from './deleteAlertusTokenSlice';
import { getCookie } from '../../common/utils';
import useNotification from '../notification/useNotification';
import { listAlertusTokens } from '../../pages/integrations/alertus/listAlertusTokenSlice'; // refresh list
import { useSpinner } from "../../customHooks";

export const useDeleteAlertusTokenModal = (id?: string) => {
  const [tokenId, setTokenId] = useState<string>(id ?? '');
  const [show, setShow] = useState(false);
  const dispatch: any = useDispatch();
  const deleteTokenResponse = useSelector(deleteTokenApi);
  useSpinner(deleteTokenResponse.status);

  const { showSuccessNotification, showWarningNotification } = useNotification();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDeleteButtonClick = () => {
    const orgId = getCookie('organizationId');
    dispatch(deleteAlertusToken({ entryId: tokenId, orgId }))
      .then((response: any) => {
        if (response.meta && response.meta.requestStatus === 'fulfilled') {
          showSuccessNotification(response.payload.message);
          dispatch(listAlertusTokens()); // refresh table
        } else {
          showWarningNotification(response.payload?.response?.data?.message || "Failed to delete token");
        }
      })
      .catch(() => {
        showWarningNotification("Something went wrong while deleting");
      });
      setShow(false);
  };

  return {
    show,
    handleDeleteButtonClick,
    handleClose,
    handleShow,
    setTokenId
  };
};
